import axios from 'axios';
import _ from 'lodash';
import { typesCruisefare } from '../svtypes/cruisefareTypes'
import { SV_SOJ_ORCMOCK_ADDRESS, CARN_URL, IM_SOURCE_TYPE, IM_AWS, IM_CDN, IM_SVAMCOS, COSMOS_IM_URL, IM_PSURLS_AWS, SROOMIM_SOURCE_TYPE, CDN_PROM_ADDRESS } from '../../constants';

const headers = { 'Content-Type': 'application/json' }
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
        accumulator[key.toLowerCase()] = obj[key];
        return accumulator;
    }, {});
}



export const getCruisedetSuccess = (data) => dispatch => {
    dispatch({
        type: typesCruisefare.GET_CRUISEFARE_SUCCESS,
        payload: data
    })
}
export const getCruisedetMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesCruisefare.GET_CRUISEFARE_SUCCESS,
        payload: data
    })
}

export const getCruisedetBegin = () => dispatch => {
    dispatch({
        type: typesCruisefare.GET_CRUISEFARE_BEGIN

    })
}

export const getCruisedetError = (e) => dispatch => {
    dispatch({
        type: typesCruisefare.GET_CRUISEFARE_ERROR,
        error: e
    })
}






/*svjun9 start ***********/

export function cliAndImagesFarelById(sojPostRqFromPage, svcli_esquery_data) {
    


    return dispatch => {
        dispatch(getCruisedetBegin())
       
        let urlBridge = null
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcSRByExcursionId`
        if (IM_SOURCE_TYPE == IM_AWS) {
            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/`

        } else if (IM_SOURCE_TYPE == IM_PSURLS_AWS) {

            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcSRByExcursionId_ps`

        } else {

            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcSRByExcursionId`
        }

        let sojPostRq = {
            "docId": ["1659"],
            "hsetname": "MSC"
        }


        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`

        if (sojPostRqFromPage) {
            if (_.isObject(sojPostRqFromPage)) {
                sojPostRq = sojPostRqFromPage
            }

        }
        sojPostRq.hsetname = "NA"


        axios.all([
            axios.post(urlSoj, sojPostRq, { headers: headers }),
            axios.get(urlSojImages, { headers: headers }),

        ])
            .then(
                axios.spread((rFobAx, r2) => {

                    let rFobMerge = rFobAx.data
                    const { crProducts } = rFobMerge
                    let svcfare = null
                    let ship_cabincategories = []
                    const comData = { my_data: [], my_data_geo: {} }
                    if (crProducts && (crProducts.length > 0)) {

                        let crProduct_SVR = null
                        for (let i = 0; i < crProducts.length; i++) {
                            let crProduct = crProducts[i]
                            if (crProduct.id == 'SVCT070126') {
                                crProduct_SVR = crProduct
                                break
                            }

                        }
                        if (crProduct_SVR != null && (crProduct_SVR.crCruises) && (crProduct_SVR.crCruises.length > 0) && (crProduct_SVR.crCruises[0].prices)) {
                            svcfare = crProduct_SVR.crCruises[0]
                            let prices = crProduct_SVR.crCruises[0].prices
                            if (prices && (prices.cabincategories) && (prices.cabincategories.length > 0)) {
                                ship_cabincategories = prices.cabincategories
                            }
                        }

                       
                        let ess = ship_cabincategories
                        
                        for (let m = 0; m < ess.length; m++) {
                            let a_ess = ess[m]
                            let code = a_ess.code
                            let brand = a_ess.brand
                            let idBrandCode = a_ess.idBrandCode ? a_ess.idBrandCode : 'XX'

                            
                            let srimpath = a_ess.srimpath
                            let im = ''
                            if (SROOMIM_SOURCE_TYPE == IM_AWS) {
                               
                                im = `${SV_SOJ_ORCMOCK_ADDRESS}/images/00/CABINS/${srimpath}`
                                
                            } else if (SROOMIM_SOURCE_TYPE == IM_PSURLS_AWS) {
                                im = `${srimpath}`
                            } else if (SROOMIM_SOURCE_TYPE == IM_CDN) {
                                im = `${CDN_PROM_ADDRESS}${srimpath}}`

                            } else {

                                im = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`
                                
                            }
                          


                            ess[m].img_paths = im
                        }
                       

                        comData.my_data = ess


                    } else {
                        console.log('86 sending svo null')


                    }
                    comData.svcli_esquery_data = svcli_esquery_data
                    dispatch(getCruisedetMultiplceCallsSuccess(comData))



                }
                )
            ).catch(
                e => { dispatch(getCruisedetError(e)) }

            )
    }
}

/*svjun9 end*/